import { PropTypes } from "prop-types"
import classNames from "classnames"

import Input from "../Input"

const handleKeyDown = e => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()

export const InputNumber = ({ className, ...rest }) => {
  const handleChange = e => {
    const { max, onChange } = rest
    // deriving maxLength from maxValue... genius
    const maxLength = max && max.toString().length

    if (!maxLength || e.target.value.toString().length <= maxLength) {
      let newValue = e.target.value
      if (newValue > max) {
        newValue = max
      }
      onChange({ ...e, target: { ...e.target, value: newValue } })
    }
  }

  return (
    <Input
      className={classNames("oj-input-number", className)}
      type="number"
      {...rest}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  )
}

InputNumber.propTypes = {
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.number,
  max: PropTypes.number,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default InputNumber
